import React, { Component } from 'react'
import moment from 'moment'
import { translate } from "react-i18next"

import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import './customDate.css'

class CustomDate extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.value ? props.value : null,
      error: null,
    }

    this.handleDateChanged = this.handleDateChanged.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleDateChanged(date) {
    this.setState({
      value: moment(date).format('YYYY-MM-DD')
    })
  }

  handleSubmit() {
    if (this.props.required && !this.state.value){
      this.setState({ error: true })
      setTimeout(() => { this.setState({ error: false }) }, 500)
      return
    }

    // Add a small delay before submitting for user visual feedback
    setTimeout(() => {
      this.props.onSubmit(this.state.value)
    }, 250)
  }

  handleInputClick(e) {
    if (e.target.classList.contains('react-datepicker__navigation--years') || e.target.classList.contains('react-datepicker__year-option')) {
      return
    }
    setTimeout(function() {
      const el = document.querySelector('.react-datepicker__year-option:nth-child(100)')
      if (el) {
        el.scrollIntoView()
      }
    }, 100)
  }

  render() {
    const { color } = this.props

    const dateFormat = datePickerFormatFor(this.props.dateFormat)

    const selected = this.state.value ? moment(this.state.value).toDate() : null

    return (
      <div className="booking-input booking-input-date inside-button" onClick={this.handleInputClick}>
        <div className={`booking-input-wrapper ${ this.state.error ? 'shake' : '' }`}>
          <DatePicker
            dateFormat={dateFormat}
            selected={selected}
            onChange={this.handleDateChanged}
            inputProps={{ readOnly: true }}
            onFocus={e => e.target.blur()}
            startOpen={true}
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100}
            yearDropdownScrollToSelected
          />
          <button onClick={this.handleSubmit} style={{ backgroundColor: color }}>{this.props.okButtonLabel}</button>
        </div>
      </div>
    )
  }
}

export default translate("translations")(CustomDate)


function datePickerFormatFor(format) {
  return format.replace(/dddd/gi, 'eeee').replace(/D/gi, 'd').replace(/Y/gi, 'y')
}
